import { FunctionComponent, useContext, useEffect, Fragment } from 'react';
import { counterTrigger } from 'Tools/counters';
import getByPath from 'Tools/getByPath';
import { AddPetContext } from 'Components/AddPet/AddPet';
import * as s from './ThirdStep.css';
import PetsInput from '../PetsInput';
import PetsCheckbox from '../PetsCheckbox';
const ThirdStep: FunctionComponent = () => {
    const addPetContext = useContext(AddPetContext);
    const isAddPetPurinaRequired = addPetContext?.isAddPetPurinaRequired;
    const petsshopPromoRules = addPetContext?.petsshopPromoRules;
    const isPetsshop = addPetContext?.isPetsshop;
    const remote = addPetContext?.remote;
    const theme = isPetsshop ? 'petsshop' : 'simple';
    const userFullNameValue = getByPath('form.fields.user_full_name.value', remote);
    const userEmailValue = getByPath('form.fields.user_email.value', remote);
    const userPhoneValue = getByPath('form.fields.user_phone.value', remote);
    const emailPattern = {
        value: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
        message: 'Введите корректный адрес электронной почты.',
    };
    const phonePattern = {
        value: /(^[+]\d [(]\d{3}[)] \d{3}-\d{2}-\d{2})/gm,
        message: 'Введите корректный номер телефона',
    };
    const AgreementAcceptedText = isPetsshop
        ? 'Принимая участие, я соглашаюсь с '
        : 'Согласен с условиями ';
    const AgreementAcceptedLinkText = isPetsshop
        ? 'условиями правил акции'
        : 'Пользовательского соглашения';
    const AgreementAcceptedLink = isPetsshop
        ? petsshopPromoRules
        : 'https://help.mail.ru/legal/terms/pets/ua';
    useEffect(() => {
        counterTrigger('addPetWindowThirdStep');
    }, []);
    return (<section className="ThirdStepWrapper">
      <div className={s.rootSection}>
        <PetsInput theme={theme} name="user_full_name" label="ФИО" placeholder="Введите ваши ФИО" defaultValue={userFullNameValue}></PetsInput>
        <PetsInput theme={theme} name="user_email" label="Email" placeholder="Введите ваш Email" defaultValue={userEmailValue} required triggerOnChange pattern={emailPattern}></PetsInput>
        <PetsInput theme={theme} name="user_phone" label="Номер телефона" mask="+0 (000) 000-00-00" placeholder="Введите ваш номер телефона" defaultValue={userPhoneValue} required triggerOnChange pattern={phonePattern}></PetsInput>
        <PetsCheckbox theme={theme} name="is_agreement_accepted">
          {AgreementAcceptedText}
          <a href={AgreementAcceptedLink as string} rel="noreferrer" target="_blank">
            {AgreementAcceptedLinkText}
          </a>
          {!isPetsshop && (<Fragment>
              {' и '}
              <a href="https://help.mail.ru/legal/terms/pets/privacypolicy" rel="noreferrer" target="_blank">
                Политикой конфиденциальности Mail
              </a>
            </Fragment>)}
        </PetsCheckbox>
        {!isPetsshop && (<PetsCheckbox theme={theme} name="send_data_to_purina" required={isAddPetPurinaRequired}>
            Отмечая «Согласен» в чек-боксе, я даю согласие на обработку моих
            персональных данных ООО «Нестле Россия» в соответствии с политикой
            об обработке данных. Подробнее о{' '}
            <a href="https://www.purina.ru/sites/default/files/2024-05/Consent_purina_petsmail.pdf" rel="noreferrer" target="_blank">
              согласии
            </a>
            {' и '}
            <a href="https://www.purina.ru/sites/default/files/2023-11/data_policy_17112023.pdf?_ga=2.159700413.1852342619.1710747758-38100825.1709202614" rel="noreferrer" target="_blank">
              политике.
            </a>
          </PetsCheckbox>)}
        <PetsCheckbox theme={theme} name="is_communication_agreement_accepted">
          Согласен на получение рекламно-информационной рассылки по электронной
          почте в отношении брендов и мероприятий ООО «Нестле Россия»
        </PetsCheckbox>
      </div>
    </section>);
};
export default ThirdStep;
